import React, { useEffect, useRef } from "react";
import WavyDivider from "./WavyDivider";
import { siteData } from "../mock";

const SeanceSlider = () => {
  const images = [siteData.images.seance1, siteData.images.zen1, siteData.images.seance2, siteData.images.zen2, siteData.images.seance3, siteData.images.zen4];
  const loop = [...images, ...images, ...images];
  const trackRef = useRef(null);

  useEffect(() => {
    let raf;
    let x = 0;
    const speed = 0.35;
    const step = () => {
      if (trackRef.current) {
        x -= speed;
        const w = trackRef.current.scrollWidth / 3;
        if (-x >= w) x += w;
        trackRef.current.style.transform = `translateX(${x}px)`;
      }
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="seance-slider">
      <div className="seance-track" ref={trackRef}>
        {loop.map((src, i) => (
          <div className="seance-slide" key={i}>
            <img src={src} alt="Séance" />
          </div>
        ))}
      </div>
    </div>
  );
};

const Seance = () => {
  return (
    <section id="seances" className="section seance">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Comment se déroule une séance&nbsp;?</h2>
        <h3 className="section-subtitle">
          Chaque séance est adaptée à la personne qui consulte afin de répondre au mieux au motif de sa visite.
        </h3>
      </div>

      <SeanceSlider />

      <div className="seance-content">
        <div className="seance-photos">
          <img src={siteData.images.seance1} alt="Séance 1" className="photo-a" />
          <img src={siteData.images.seance3} alt="Séance 2" className="photo-b" />
          <img src={siteData.images.seance2} alt="Séance 3" className="photo-c" />
        </div>
        <div className="seance-text">
          <p>
            Un <strong>court questionnaire</strong> en début de rendez-vous permet de connaître les antécédents médicaux éventuels et les attentes de la personne qui consulte.
          </p>
          <p>
            Le Shiatsu <strong>se pratique habillé</strong> — dans des vêtements souples — <strong>sur une chaise ergonomique, une table de massage ou au sol sur un futon</strong>.
          </p>
          <p>
            Je travaille sur les méridiens et les points d’acupuncture, en <strong>exerçant des pressions avec les pouces et les paumes de mains</strong>. Je réalise des mobilisations articulaires et étirements pour débloquer l’énergie stagnant dans les méridiens.
          </p>
          <p>
            Tout est mis en œuvre afin de restaurer la libre circulation de l’énergie dans tout le corps et d’apporter une détente profonde.
          </p>
          <p className="muted-note">
            Ce soin ne se substitue pas à un traitement médical approprié, mais peut être utilisé en complément.
          </p>
          <a href="#contact" className="btn btn-primary">PRENDRE UN RDV</a>
        </div>
      </div>
    </section>
  );
};

export default Seance;
